import util from './util';

export default class VampiVoiceClient {
	constructor(baseUrl, key) {
		if(!baseUrl) throw new Error('No API URL specified');
		if(!key) throw new Error('No API key specified');
		this.baseUrl = baseUrl;
		this.apiKey = key;
	}

	getSpeechUrl(text, provider, voice, rate, pitch, style, role) {
		return `${this.baseUrl}/api/synthesizeSpeech?${new URLSearchParams({ provider, voice, rate, pitch, text, style, role })}`;
	}

	synthesizeRequest(text, provider, voice, rate, pitch, style, role, timeoutMs) {
		const url = this.getSpeechUrl(text, provider, voice, rate, pitch, style||'', role||'');
		return util.fetchWithTimeout(url, {
			withCredentials: true,
			credentials: 'include',
			headers: {
				Authorization: this.apiKey,
			},
		}, timeoutMs);
	}

	synthesizeSpeech(text, provider, voice, rate, pitch, style, role, timeoutMs) {
		return this.synthesizeRequest(text, provider, voice, rate, pitch, style, role, timeoutMs).then(r => r.arrayBuffer());
	}
}
